import React, {useEffect, useState} from 'react';
import Layout from '../components/Layout';
import {api} from '../../api';

function OrgNode({node, nodes, level = 0}) {
  const children = nodes.filter(n => n.managerId === node.id);
  return (
    <div className={level > 0 ? 'ml-8 border-l-2 border-indigo-200 pl-4' : ''}>
      <div className="flex items-center gap-3 py-2">
        <div className="w-10 h-10 rounded-full bg-indigo-100 text-indigo-700 flex items-center justify-center font-bold text-sm flex-shrink-0">
          {node.name?.split(' ').map(w => w[0]).join('').slice(0, 2)}
        </div>
        <div>
          <p className="font-medium text-gray-900">{node.name}</p>
          <p className="text-sm text-gray-500">{[node.jobTitle, node.department].filter(Boolean).join(' · ') || '—'}</p>
        </div>
      </div>
      {children.map(c => <OrgNode key={c.id} node={c} nodes={nodes} level={level + 1} />)}
    </div>
  );
}

export default function OrgChart() {
  const [nodes, setNodes] = useState([]);

  useEffect(() => {
    api('/hcm/org-chart').then(r => r.json()).then(setNodes).catch(() => {});
  }, []);

  const roots = nodes.filter(n => !n.managerId || !nodes.some(o => o.id === n.managerId));

  return (
    <Layout>
      <div className="bg-white rounded-lg shadow">
        <div className="p-4 md:p-6 border-b">
          <h1 className="text-2xl font-bold text-gray-900">Org Chart</h1>
        </div>
        <div className="p-4 md:p-6">
          {nodes.length === 0 ? (
            <p className="text-gray-500 text-center py-8">No employees found.</p>
          ) : (
            roots.map(r => <OrgNode key={r.id} node={r} nodes={nodes} />)
          )}
        </div>
      </div>
    </Layout>
  );
}
